class MemoryStore {
  constructor() {
    this.store = {};
  }

  load(key
  /*: string*/
  )
  /*: any*/
  {
    return this.store[key];
  }

  save(key
  /*: string*/
  , value
  /*: any*/
  ) {
    this.store[key] = value;
  }

}

module.exports = MemoryStore;